import { AxiosRequestConfig } from 'axios';
import api from './api';
import { RequestSurveillancePostType, SurveilanceType, SurveilancesResponseType, SurveillanceResponse } from '../@types/surveilanceTypes';

const surveillanceUrl = '/api/surv_records/';
const mapSurvUrl = 'map_side_list/';

// * Main * \\

function getSurveillances(config: AxiosRequestConfig) {
	return api.get<SurveilancesResponseType>(surveillanceUrl, config);
}

function getSurveillancesTileKey(config: AxiosRequestConfig) {
	return api.get<string>(surveillanceUrl, config);
}

function getSurveillanceById(id: string) {
	return api.get<SurveilanceType>(`${surveillanceUrl}${id}/`);
}

async function deleteSurveillanceById(id: string) {
	return api.delete(`${surveillanceUrl}${id}/`);
}

function createSurveillance(surveillancesData: SurveillanceResponse) {
    return api.post(surveillanceUrl, surveillancesData.record);
}

function updateSurveillance(id: string, updatedSurveillancesData: RequestSurveillancePostType) {
  	return api.put(`${surveillanceUrl}${id}/`, updatedSurveillancesData);
}

// * Map * \\

function getSurvMapInformation(config: AxiosRequestConfig) {
	return api.get(`${surveillanceUrl}${mapSurvUrl}`, config);
}

// * Exports * \\

const surveillanceServices = {
	getSurveillances,
	getSurveillancesTileKey,
	getSurveillanceById,
	deleteSurveillanceById,
	createSurveillance,
	updateSurveillance,
	getSurvMapInformation
};

export default surveillanceServices;